import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { ReactNode } from 'react';

export const Route = createFileRoute('/surveys_/$surveyId')({
  component: SurveyDetailLayout,
});

function SurveyDetailLayout(): ReactNode {
  return <Outlet />;
}
